import React from 'react';
import { API_DOCS, SUBAGENT_AGREEMENT_SHOW_ID } from '../consts/apiDocs.const';

interface CheckoutMiniFooterProps {
  showId?: number;
}

/**
 * Мини-футер страницы оформления заказа.
 * Предоставляет пользователю быстрый доступ к документам:
 * - «Способы оплаты, доставки и возврата»
 * - «Реквизиты»
 * Ссылки открываются в новой вкладке.
 */
export const CheckoutMiniFooter: React.FC<CheckoutMiniFooterProps> = ({ showId }) => {
  return (
    <div className="mt-6">
      <div className="border-t border-separator" />
      <div className="mt-3 text-center text-xs text-text-muted space-x-3">
        <a
          href={API_DOCS.CONDITIONS}
          target="_blank"
          rel="noopener noreferrer"
          className="text-text-link hover:text-text-link-hover hover:underline"
        >
          Способы оплаты, доставки и возврата
        </a>
        <span className="text-text-secondary">•</span>
        <a
          href={API_DOCS.COMPANY_INFO}
          target="_blank"
          rel="noopener noreferrer"
          className="text-text-link hover:text-text-link-hover hover:underline"
        >
          Реквизиты
        </a>
        {showId === SUBAGENT_AGREEMENT_SHOW_ID && (
          <>
            <span className="text-text-secondary">•</span>
            <a
              href={API_DOCS.PARTNERDOC}
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-link hover:text-text-link-hover hover:underline"
            >
              Субагентский договор
            </a>
          </>
        )}
      </div>
    </div>
  );
};
